<template>
  <div id="css">
    <div class="css-container mk-container">
      <div class="main">
        <CSSSearchBanner />
        <CSSArticleBanner />
        <Paganiniplus class="hide-xl" />
        <CSSScenarioList :text-position="'inside'" :placeholder-num="8" />
        <Paganiniplus class="hide-xl" />
        <!-- <CSSEventTable /> -->
      </div>
      <div class="side">
        <Paganiniplus />
        <Paganiniplus />
        <Paganiniplus />
        <Paganiniplus />
        <Paganiniplus />
        <Paganiniplus />
        <Paganiniplus />
        <Paganiniplus />
      </div>
    </div>
  </div>
</template>

<script>
import Paganiniplus from '@/components/tsp/Paganiniplus'
import CSSSearchBanner from '@/components/css-web/CSSSearchBanner'
import CSSArticleBanner from '@/components/css-web/CSSArticleBanner'
import CSSScenarioList from '@/components/css-web/CSSScenarioList'
// import CSSEventTable from '@/components/css-web/CSSEventTable'

export default {
  name: 'ClassicalSuperSearch',
  components: {
    Paganiniplus,
    CSSSearchBanner,
    CSSArticleBanner,
    CSSScenarioList
    // CSSEventTable
  },
  props: {},
  data() {
    return {

    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        ...this.$route.meta.metaInfo.meta,
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    title() {
      return `${this.$t('CSS.TITLE')} | MUZIK ${this.$production.toUpperCase()}`
    },
    description() {
      return this.$t('CSS.META_DESCRIPTION')
        ? `${this.$t('CSS.META_DESCRIPTION')} | ${this.title}`
        : this.title
    },
    keywords() {
      return this.$te('CSS.META_KEYWORDS')
        ? this.$t('CSS.META_KEYWORDS') || this.$t('CSS.TITLE')
        : this.$t('CSS.TITLE')
    },
    cover() {
      return `https://${process.env.VUE_APP_MUZIK_CSS}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/css.jpg`
    },
    canonicalURL() {
      return `https://${process.env.VUE_APP_MUZIK_CSS}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`
    },
    structuredData() {
      return [{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        '@id': this.canonicalURL,
        url: this.canonicalURL,
        image: this.cover,
        name: this.title,
        description: this.description,
        author: {
          '@type': 'Organization',
          sameAs: [
            'https://facebook.com/muzikcom/',
            'https://www.instagram.com/muzikmagazine/',
            'http://line.me/ti/p/@pwr7122w#~',
            'https://www.youtube.com/user/MUZIKmagazine'
          ]
        },
        relatedLink: [
          `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${process.env.VUE_APP_MUZIK_CSS}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/terms`,
          `https://${process.env.VUE_APP_MUZIK_CSS}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`,
          `https://${process.env.VUE_APP_MUZIK_CSS}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/about`,
          `https://${process.env.VUE_APP_MUZIK_CSS}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/mediaKit`
        ]
      },
      {
        '@context': 'http://schema.org',
        '@type': 'Organization',
        url: `https://${process.env.VUE_APP_MUZIK_CSS}.${process.env.VUE_APP_MUZIK_DOMAIN}`,
        logo: {
          '@type': 'ImageObject',
          'url': this.cover
        }
      }]
    }
  },
  watch: {},
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.css-container {
  margin-top: 24px;
  .main {
    width: 100%;
  }
  .side {
    display: none;
  }
}
@media only screen and (min-width: 1440px) {

  .css-container {
    position: relative;
    overflow: hidden;
    margin-top: 24px;
    .hide-xl {
      display: none;
    }
    .main {
      position: relative;
      overflow: hidden;
      margin-right: 47px;
      float: left;
      width: calc(100% - 322px - 47px);
    }
    .side {
      display: inline-block;
      position: relative;
      overflow: hidden;
      width: 322px;
    }
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
</style>
